import { Provider } from "@redotech/redo-model/order";
import * as z from "zod/v4";

export const getEnabledProviders = {
  name: "getEnabledProviders" as const,
  input: z.object({}),
  output: z.array(z.enum(Provider)),
};
